import { render, staticRenderFns } from "./personal_center.vue?vue&type=template&id=118b1c74&scoped=true&"
import script from "./personal_center.vue?vue&type=script&lang=js&"
export * from "./personal_center.vue?vue&type=script&lang=js&"
import style0 from "./personal_center.vue?vue&type=style&index=0&id=118b1c74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b1c74",
  null
  
)

export default component.exports